import React, { useEffect, useState, useRef } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
} from "reactstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import axios from "axios";
import AxiosInstance from "../../../utils/axiosInstance";
import moment from "moment";
import { useUserTimezoneFormatter } from "../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import "../style.css";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, Button, Grid, TableBody, TableCell, TableHead, TableRow, CircularProgress, Chip } from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import HourglassBottomOutlinedIcon from "@mui/icons-material/HourglassBottomOutlined";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import { LoaderComponent, ProductItem } from "../../../components/Icon/Index";
import { Card as MuiCard, CardHeader as MuiCardHeader, CardContent as MuiCardContent } from "@mui/material";
import showToast from "../../../components/Toast/Toster";
import BlueButton from "../../../components/Button/BlueButton";
import WhiteButton from "../../../components/Button/WhiteButton";
import CloseIcon from "@mui/icons-material/Close";
import ZoomIn from "@mui/icons-material/ZoomIn";
import ZoomOut from "@mui/icons-material/ZoomOut";
import { DisplayImage } from "../../../components/Files/DisplayFiles";
import { handleAuth } from "../../../components/Login/Auth";

function InvoiceDetails() {
  const [DateDecode, setDateDecode] = useState("MM/DD/YYYY");
  const baseUrl = import.meta.env.VITE_BASE_API;

  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();

  const [signatureRef, setSignatureRef] = useState(null);
  const navigate = useNavigate();

  const clearSignature = () => {
    signatureRef?.clear();
  };

  const [typedSignature, setTypedSignature] = useState("");

  const location = useLocation();

  const [modal, setModal] = useState(false);
  const [modall, setModall] = useState(false);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [imageZoom, setImageZoom] = useState(100);
  const imgRef = useRef(null);
  const [failedImages, setFailedImages] = useState(new Set());

  const togglee = () => setModall(!modall);
  const setTabId = (tabId) => {
    if (activeTab !== tabId) {
      setActiveTab(tabId);
    }
  };
  const [activeTab, setActiveTab] = useState(1);

  const [invoiceDetail, setinvoiceDetail] = useState("");
  const fetchDateData = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setDateDecode(res?.themes?.Format || "MM/DD/YYYY");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchDateData();
  let fetchData = async () => {
    try {
      const res = await AxiosInstance.get(
        `/v1/invoice/invoice_detail/${location?.state?.id}`
      );
      setinvoiceDetail(res?.data?.data);
    } catch (error) {
      console.error("Error: ", error?.message);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const updateImageSize = () => {
    if (imgRef.current && previewImage && previewDialogOpen) {
      const img = imgRef.current;
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;
      
      if (naturalWidth > 0 && naturalHeight > 0) {
        const containerWidth = img.parentElement?.clientWidth || 560;
        const padding = 40;
        const availableWidth = containerWidth - padding;
        
        if (imageZoom === 100) {
          // At 100%, fit to container (maintain aspect ratio)
          img.style.width = "auto";
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          img.style.maxHeight = "none";
        } else {
          // When zoomed, use the displayed width at 100% as base
          // First, get what the width would be at 100%
          const displayWidthAt100 = Math.min(naturalWidth, availableWidth);
          // Then apply zoom to that base width
          const zoomedWidth = (displayWidthAt100 * imageZoom) / 100;
          img.style.width = `${zoomedWidth}px`;
          img.style.height = "auto";
          img.style.maxWidth = "none";
          img.style.maxHeight = "none";
        }
      }
    }
  };

  useEffect(() => {
    updateImageSize();
  }, [imageZoom, previewImage, previewDialogOpen]);

  const handleImageClick = (imageUrl) => {
    setPreviewImage(imageUrl);
    setPreviewDialogOpen(true);
    setImageZoom(100); // Reset zoom when opening
  };

  const handleClosePreview = () => {
    setPreviewDialogOpen(false);
    setPreviewImage("");
    setImageZoom(100); // Reset zoom when closing
  };

  const handleZoomIn = () => {
    setImageZoom((prev) => Math.min(prev + 25, 300)); // Max 300%
  };

  const handleZoomOut = () => {
    setImageZoom((prev) => Math.max(prev - 25, 50)); // Min 50%
  };

  const handleResetZoom = () => {
    setImageZoom(100);
  };

  const handleDownload = async () => {
    if (previewImage) {
      try {
        const response = await fetch(previewImage);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = previewImage.split("/").pop() || "attachment";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      } catch (error) {
        console.error("Error downloading file:", error);
        // Fallback: try direct download without opening in new tab
        const link = document.createElement("a");
        link.href = previewImage;
        link.download = previewImage.split("/").pop() || "attachment";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
      }
    }
  };

  const handleImageError = (imageUrl) => {
    setFailedImages(prev => new Set(prev).add(imageUrl));
  };

  const isImageFailed = (imageUrl) => {
    return failedImages.has(imageUrl);
  };

  const [savedSignature, setSavedSignature] = useState(null);
  const [signatureSaved, setSignatureSaved] = useState(false);
  const [loader, setLoader] = useState(true);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressIntervalRef = useRef(null);
  const [changeRequestReason, setChangeRequestReason] = useState("");

  const saveSignature = async () => {
    const labelElement = document.getElementById("typeSignatureLabel") || "";
    let image = "";
    let changeRequest = {
      CustomerId: "11062024191201",
      reason: changeRequestReason,
      date: moment().format("MM/DD/YYYY HH:mm:ss"),
    };
    if (activeTab === 2 && typedSignature && labelElement) {
      try {
        const canvas = await html2canvas(labelElement);
        const signatureData = canvas.toDataURL();

        const signatureBlob = dataURLtoBlob(signatureData);
        const imageData = new FormData();
        imageData.append("files", signatureBlob, "signature.png");

        const url = `${baseUrl}/v1/cdn/upload`;
        const result = await axios.post(url, imageData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setSavedSignature(signatureData);
        image = result?.data?.files[0]?.filename;
      } catch (error) {
        const msg = (error?.response?.data?.message || "").toString();
        const isFileTooLarge =
          error?.response?.status === 413 ||
          (error?.response?.status === 400 && /file size too large/i.test(msg));
        if (isFileTooLarge) {
          showToast.warning("File size too large");
        }
        console.error(error, "imgs");
      }
    } else if (activeTab === 1 && signatureRef) {
      try {
        const signatureCanvas = signatureRef;
        const signatureDataURL = signatureCanvas.toDataURL();
        const signatureBlob = await fetch(signatureDataURL).then((res) =>
          res.blob()
        );

        const imageData = new FormData();
        imageData?.append("files", signatureBlob, "signature.png");

        const url = `${baseUrl}/v1/cdn/upload`;
        const result = await axios.post(url, imageData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setSavedSignature(signatureDataURL);
        image = result?.data?.files[0]?.filename;
      } catch (error) {
        const msg = (error?.response?.data?.message || "").toString();
        const isFileTooLarge =
          error?.response?.status === 413 ||
          (error?.response?.status === 400 && /file size too large/i.test(msg));
        if (isFileTooLarge) {
          showToast.warning("File size too large");
        }
        console.error(error, "imgs");
      }
    } else {
    }
    setSignatureSaved(true);

    // JOB-3316: legacy PUT to /invoices/clientdashboard/:id removed — that
    // backend route never existed (no match in api/src/routes), so the call
    // produced a 404 and surfaced an error toast to customers even though
    // the signature image had already uploaded to CDN successfully above.
    // Persisting the signature/change_request to the invoice record needs a
    // backend route to be added; track that as follow-up work.
    if (image) {
      showToast.success("Signature saved.");
    }
    setModal(false);
    setModall(false);
  };

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  // Helper function to sanitize filename by removing/replacing invalid characters
  const sanitizeFileName = (str) => {
    if (!str) return "";
    return str
      .replace(/[<>:"/\\|?*]/g, "") // Remove invalid filename characters
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .trim();
  };

  // Helper function to generate a readable PDF filename
  const generatePDFFileName = () => {
    const customerFirstName = invoiceDetail?.FirstName || "";
    const customerLastName = invoiceDetail?.LastName || "";
    const customerName = `${customerFirstName} ${customerLastName}`.trim();
    const invoiceNumber = invoiceDetail?.InvoiceNumber || "";
    const invoiceTitle = invoiceDetail?.Subject || invoiceDetail?.account_name || "";

    // Build filename parts
    const parts = ["Invoice"];
    
    if (customerName) {
      parts.push(sanitizeFileName(customerName));
    }
    
    if (invoiceNumber) {
      parts.push(`#${invoiceNumber}`);
    }
    
    if (invoiceTitle && invoiceTitle !== customerName) {
      parts.push(sanitizeFileName(invoiceTitle));
    }

    // Fallback to ID if no other info available
    if (parts.length === 1) {
      parts.push(location?.state?.id || "document");
    }

    return `${parts.join("_")}.pdf`;
  };

  const simulateProgress = () => {
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
    }
    setProgress(0);
    let simulatedProgress = 0;
    progressIntervalRef.current = setInterval(() => {
      simulatedProgress += 2;
      if (simulatedProgress >= 100) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
        setProgress(100);
      } else {
        setProgress(simulatedProgress);
      }
    }, 100);
  };

  useEffect(() => {
    return () => {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
      }
    };
  }, []);

  const [openPdfPreview, setOpenPdfPreview] = useState(false);
  const [previewPdfUrl, setPreviewPdfUrl] = useState(null);

  // Like transactions table: one action opens preview; Download is inside the dialog
  const downloadPdf = async () => {
    if (downloadingPdf) return;
    try {
      setDownloadingPdf(true);
      setProgress(0);
      simulateProgress();
      const res = await AxiosInstance.post(
        `/v1/invoice/invoicepdf/${location?.state?.id}`,
        {}
      );
      if (res?.data?.statusCode === 200 && res?.data?.fileName) {
        const url = `${baseUrl}/v1/cdn/upload/${res?.data?.fileName}`;
        const response = await fetch(url);
        if (!response?.ok) throw new Error(`HTTP error! status: ${response?.status}`);
        const blob = await response?.blob();
        const blobUrl = window?.URL?.createObjectURL(blob);
        setPreviewPdfUrl(blobUrl);
        setOpenPdfPreview(true);
      } else {
        throw new Error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error loading PDF:", error);
      showToast.error(error?.message || "Failed to load PDF");
    } finally {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
      }
      setProgress(0);
      setDownloadingPdf(false);
    }
  };

  const handleClosePdfPreview = () => {
    if (previewPdfUrl && previewPdfUrl.startsWith("blob:")) {
      window?.URL?.revokeObjectURL(previewPdfUrl);
    }
    setPreviewPdfUrl(null);
    setOpenPdfPreview(false);
  };

  const handleDownloadFromPreview = () => {
    if (!previewPdfUrl) return;
    const link = document.createElement("a");
    link.href = previewPdfUrl;
    link.download = generatePDFFileName();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showToast.success("PDF downloaded successfully!");
  };

  const toggle = () => setModal(!modal);
  return (
    <>
      <Grid>
        {downloadingPdf ? (
          <Grid
            className="d-flex flex-direction-row justify-content-center align-items-center"
            style={{ height: "80vh" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <CircularProgress
                variant="determinate"
                value={progress}
                size={90}
                thickness={2}
                sx={{ color: "#D4943A" }}
              />
              <Typography
                className="text-blue-color"
                variant="caption"
                component="div"
                color="textSecondary"
                style={{
                  position: "absolute",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                {`${progress}%`}
              </Typography>
            </Box>
          </Grid>
        ) : loader ? (
          <Grid
            className="d-flex flex-direction-row justify-content-center align-items-center p-5 m-5"
            style={{ height: "80vh", marginTop: "25%" }}
          >
            <LoaderComponent loader={loader} height="50" width="50" />
          </Grid>
        ) : (
          <Grid
            className="customer-invoice-details-root"
            sx={{
              width: "100%",
              maxWidth: "100%",
              px: { xs: 0.5, sm: 1, md: 0 },
              boxSizing: "border-box",
            }}
          >
            <Box
              className="customer-invoice-actions-row download-sec"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "stretch", sm: "center" },
                mb: 2,
                p: { xs: 1, sm: 2 },
                backgroundColor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                boxShadow: (t) =>
                  t.palette.mode === "dark" ? "0 1px 3px rgba(0,0,0,0.35)" : "var(--shadow-md)",
                gap: { xs: 2, sm: 0 },
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
                <IconButton
                  onClick={() => navigate(-1)}
                  aria-label="Go back"
                  sx={{
                    backgroundColor: "var(--bg-blue-color)",
                    color: "white",
                    flexShrink: 0,
                    "&:hover": { backgroundColor: "#052a4f" },
                    width: { xs: 36, sm: 40 },
                    height: { xs: 36, sm: 40 },
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
                </IconButton>
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: "var(--text-blue-color)",
                      fontSize: { xs: "1.1rem", sm: "1.5rem" },
                    }}
                  >
                    Invoice Details
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      wordBreak: "break-word",
                    }}
                  >
                    #{invoiceDetail?.InvoiceNumber || "N/A"} •{" "}
                    {invoiceDetail?.Subject
                      ? invoiceDetail?.Subject
                      : invoiceDetail?.account_name || "Untitled"}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {(() => {
                  const status = invoiceDetail?.Status;
                  const statusBg =
                    status === "Paid"
                      ? "#AEF6D3"
                      : status === "Unpaid" || status === "Past Due"
                      ? "#FEE2E2"
                      : status === "Canceled"
                      ? "#F1F5F9"
                      : "#f5f5f5";
                  const statusColor =
                    status === "Paid"
                      ? "#089F57"
                      : status === "Unpaid" || status === "Past Due"
                      ? "#DC2626"
                      : status === "Canceled"
                      ? "#475569"
                      : "#475569";
                  const StatusIcon =
                    status === "Paid"
                      ? CheckCircleOutlinedIcon
                      : status === "Unpaid" || status === "Past Due"
                      ? AccessTimeOutlinedIcon
                      : status === "Canceled"
                      ? DoNotDisturbAltOutlinedIcon
                      : CheckCircleOutlinedIcon;
                  return (
                    <Chip
                      icon={<StatusIcon />}
                      label={status || "Status not available"}
                      sx={{
                        backgroundColor: statusBg,
                        color: statusColor,
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        width: { xs: "100%", sm: "auto" },
                        justifyContent: "center",
                        "& .MuiChip-icon": {
                          color: statusColor,
                        },
                      }}
                    />
                  );
                })()}
                <Button
                  variant="outlined"
                  startIcon={<FileDownloadOutlinedIcon />}
                  onClick={downloadPdf}
                  disabled={downloadingPdf || loader}
                  sx={{
                    borderColor: "primary.main",
                    color: "primary.light",
                    backgroundColor: (t) =>
                      t.palette.mode === "dark" ? "rgba(96, 165, 250, 0.12)" : t.palette.background.paper,
                    textTransform: "uppercase",
                    "&:hover": {
                      borderColor: "primary.light",
                      backgroundColor: (t) =>
                        t.palette.mode === "dark" ? "rgba(96, 165, 250, 0.2)" : "rgba(6, 49, 100, 0.04)",
                    },
                    "&:disabled": {
                      borderColor: "action.disabled",
                      color: "action.disabled",
                      backgroundColor: (t) =>
                        t.palette.mode === "dark"
                          ? t.palette.action.disabledBackground
                          : t.palette.background.paper,
                    },
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  {downloadingPdf ? "Loading..." : "Download PDF"}
                </Button>
              </Box>
            </Box>
            <Grid>
              <Card
                style={{
                  borderRadius: "8px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                }}
                className="p-3 my-4"
              >
                <Row style={{ display: "flex", flexWrap: "wrap" }}>
                  <Grid
                    className="d-flex customerIncvoiceDetailFlex"
                    style={{ width: "100%" }}
                  >
                    <Col
                      className="col-12 col-xl-9 col-lg-9 col-md-12 propertyAddressSpacing"
                      xl={9}
                      md={9}
                    >
                      <Grid
                        className="d-flex peoprttyAddressQIdthScreenFive"
                        style={{ flexWrap: "wrap" }}
                      >
                        <Col
                          className="col-12 col-xl-4 col-lg-4 col-md-4 columnWidthSet"
                          xl={4}
                          md={4}
                        >
                          <Typography
                            className="mb-0 Sub-title text-blue-color subTitleRemoveTop"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            Property Address
                          </Typography>
                          <Typography
                            className="mb-0 text-data text-blue-color"
                            style={{
                              fontSize: "14px",
                              width: "90%",
                              whiteSpace: "pre-line",
                              lineHeight: "1.6",
                              wordWrap: "break-word",
                            }}
                          >
                            {`${invoiceDetail?.location?.Address || ""}, ${
                              invoiceDetail?.location?.City || ""
                            }\n${invoiceDetail?.location?.State || ""}, ${
                              invoiceDetail?.location?.Zip || ""
                            }`}
                          </Typography>
                        </Col>
                        <Col
                          className="col-12 col-xl-4 col-lg-4 col-md-4 columnWidthSet"
                          xl={4}
                        >
                          <Typography
                            className="mb-0 Sub-title text-blue-color subTitleRemoveTop"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            Service Address
                          </Typography>
                          <Typography
                            className="mb-0 text-data text-blue-color"
                            style={{
                              fontSize: "14px",
                              width: "90%",
                              whiteSpace: "pre-line",
                              lineHeight: "1.6",
                              wordWrap: "break-word",
                            }}
                          >
                            {`${invoiceDetail?.location?.Address || ""}, ${
                              invoiceDetail?.location?.City || ""
                            }\n${invoiceDetail?.location?.State || ""}, ${
                              invoiceDetail?.location?.Zip || ""
                            }`}
                          </Typography>
                        </Col>
                        <Col
                          className="col-12 col-xl-4 col-lg-4 col-md-4 columnWidthSet"
                          xl={4}
                        >
                          <Typography
                            className="mb-0 Sub-title text-blue-color subTitleRemoveTop"
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            Contact Details
                          </Typography>
                          <Typography
                            className="mb-0 text-data text-blue-color"
                            style={{
                              fontSize: "14px",
                              width: "90%",
                              whiteSpace: "pre-line",
                              lineHeight: "1.6",
                              wordWrap: "break-word",
                            }}
                          >
                            {invoiceDetail?.companyData?.EmailAddress ||
                              invoiceDetail?.EmailAddress ||
                              "Email not available"}
                            {"\n"}
                            {invoiceDetail?.companyData?.PhoneNumber ||
                              invoiceDetail?.PhoneNumber ||
                              "Phone not available"}
                          </Typography>
                        </Col>
                      </Grid>
                    </Col>
                    <Col className="col-12 col-xl-3 col-lg-3 col-md-12" xl={3}>
                      <Table
                        borderless
                        className="invoiceDetailLeft"
                        style={{ width: "100%" }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              className="text-blue-color"
                              style={{
                                whiteSpace: "nowrap",
                                fontSize: "14px",
                                fontWeight: 600,
                                padding: "0 6px",
                              }}
                            >
                              Invoice Details
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              className="text-blue-color"
                              style={{ fontSize: "15px", fontWeight: 600 }}
                            >
                              Issued
                            </TableCell>
                            <TableCell
                              style={{ whiteSpace: "nowrap", fontSize: "15px" }}
                              className="text-blue-color"
                            >
                              {invoiceDetail?.IssueDate
                                ? formatDateWithUserTimezone(invoiceDetail?.IssueDate, {
                                    dateFormat: DateDecode,
                                    includeSeconds: false
                                  })
                                : "Date not available"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              className="text-blue-color"
                              style={{ fontSize: "15px", fontWeight: 600 }}
                            >
                              Due
                            </TableCell>
                            <TableCell
                              className="text-blue-color"
                              style={{ fontSize: "15px" }}
                            >
                              {invoiceDetail?.DueDate
                                ? formatDateWithUserTimezone(invoiceDetail?.DueDate, {
                                    dateFormat: DateDecode,
                                    includeSeconds: false,
                                    excludeTime: true,
                                  })
                                : "Date not available"}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Col>
                  </Grid>
                </Row>
              </Card>

              <MuiCard
                className="my-4 customer-invoice-materials-card"
                sx={{
                  borderRadius: "8px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                }}
              >
                <MuiCardHeader
                  className="text-blue-color"
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    background: "transparent",
                  }}
                >
                  Materials & Labor
                </MuiCardHeader>
                <MuiCardContent sx={{ maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
                  {invoiceDetail?.Items?.length > 0 ? (
                    invoiceDetail?.Items?.map((item, index) => (
                      <ProductItem
                        key={index}
                        item={item}
                        index={index}
                        baseUrl={baseUrl}
                      />
                    ))
                  ) : (
                    <Grid className="text-center text-blue-color">
                      <Typography
                        className="mb-0"
                        style={{
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        Product/Service not available
                      </Typography>
                    </Grid>
                  )}
                </MuiCardContent>
              </MuiCard>
              {invoiceDetail?.Attachment && (
                <MuiCard
                  className="my-4"
                  style={{
                    borderRadius: "8px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                  }}
                >
                  <MuiCardHeader
                    className="text-blue-color"
                    style={{
                      fontWeight: 600,
                      fontSize: "16px",
                      background: "transparent",
                    }}
                  >
                    Attachments
                  </MuiCardHeader>
                  <MuiCardContent>
                    <Grid
                      style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                    >
                      <DisplayImage
                        files={invoiceDetail?.Attachment}
                        IsDeleted={false}
                      />
                    </Grid>
                  </MuiCardContent>
                </MuiCard>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
      <Dialog
        open={previewDialogOpen}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundColor: "background.paper",
            boxShadow: (t) =>
              t.palette.mode === "dark" ? "0 8px 32px rgba(0,0,0,0.45)" : "var(--shadow-xl)",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            borderBottom: "1px solid",
            borderColor: "divider",
            backgroundColor: "background.paper",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "18px",
              color: "text.primary",
            }}
          >
            File Preview
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
              backgroundColor: "action.hover",
              padding: "4px 8px",
              borderRadius: "8px",
            }}
          >
            <IconButton
              onClick={handleZoomOut}
              disabled={imageZoom <= 50}
              size="small"
              sx={{
                color: imageZoom <= 50 ? "action.disabled" : "text.primary",
                padding: "4px",
              }}
              title="Zoom Out"
            >
              <ZoomOut fontSize="small" />
            </IconButton>
            <Typography
              variant="body2"
              sx={{
                minWidth: "50px",
                textAlign: "center",
                color: "text.primary",
                fontWeight: 600,
                fontSize: "14px",
                padding: "0 8px",
              }}
            >
              {imageZoom}%
            </Typography>
            <IconButton
              onClick={handleZoomIn}
              disabled={imageZoom >= 300}
              size="small"
              sx={{
                color: imageZoom >= 300 ? "action.disabled" : "text.primary",
                padding: "4px",
              }}
              title="Zoom In"
            >
              <ZoomIn fontSize="small" />
            </IconButton>
            {imageZoom !== 100 && (
              <Button
                onClick={handleResetZoom}
                size="small"
                variant="outlined"
                sx={{
                  color: "text.primary",
                  borderColor: "divider",
                  marginLeft: "8px",
                  padding: "2px 12px",
                  fontSize: "12px",
                  textTransform: "none",
                  minWidth: "auto",
                }}
                title="Reset Zoom"
              >
                Reset
              </Button>
            )}
            <IconButton
              onClick={handleDownload}
              size="small"
              sx={{ 
                color: "text.primary",
                marginLeft: "8px",
                padding: "4px",
              }}
              title="Download"
            >
              <FileDownloadOutlinedIcon fontSize="small" />
            </IconButton>
            <IconButton
              onClick={handleClosePreview}
              size="small"
              sx={{
                color: "text.primary",
                marginLeft: "8px",
                padding: "4px",
              }}
              title="Close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "0",
            overflow: "auto",
            backgroundColor: "#f5f5f5",
            position: "relative",
            flex: "1 1 auto",
            minHeight: 0,
            maxHeight: "calc(90vh - 120px)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "40vh",
              padding: "20px",
              width: "100%",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <img
              ref={imgRef}
              src={previewImage}
              alt="Preview"
              onLoad={updateImageSize}
              style={{
                width: "auto",
                maxWidth: imageZoom === 100 ? "100%" : "none",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "var(--shadow-md)",
                objectFit: "contain",
                transition: "width 0.3s ease",
                display: "block",
              }}
              draggable={false}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/no-image.png";
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "8px 24px" }}>
          <WhiteButton
            onClick={handleClosePreview}
            label="Close"
          />
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPdfPreview}
        onClose={handleClosePdfPreview}
        maxWidth="lg"
        fullWidth
        style={{ background: "transparent" }}
        PaperProps={{
          sx: {
            maxHeight: "95vh",
            height: "95vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0, display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
          {previewPdfUrl && (
            <iframe
              src={previewPdfUrl}
              width="100%"
              height="100%"
              title="PDF Preview"
              style={{ minHeight: "calc(100vh - 160px)", border: "none", flex: 1 }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "10px", gap: 1 }}>
          <BlueButton onClick={handleClosePdfPreview} label="Close" />
          <BlueButton onClick={handleDownloadFromPreview} label="Download" />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default InvoiceDetails;
